import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { EmailContentService } from '../../core/services/email-content.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-email-content-list',
    imports: [RouterLink, FormsModule, DatePipe, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
    </div>
    <div class="card-body">
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate>
        <div class="row" style="align-items:flex-end;">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">状態</label>
                <select class="form-control" [(ngModel)]="statusFilter" (ngModelChange)="filtersChanged()" name="statusFilter">
                  <option [ngValue]="null">-- すべて --</option>
                  @for (so of statusOptions; track so.id) {
                    <option [ngValue]="so.id">{{ so.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row align-items-end">
              <div class="form-group col-md-8">
                <label class="col-form-label">キーワード検索</label>
                <input type="text" class="form-control" [(ngModel)]="keyword" (ngModelChange)="filtersChanged()" name="keyword" placeholder="件名など">
              </div>
              <div class="form-group col-md-4">
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          <a class="btn btn-primary text-white" routerLink="/email/content/new">
            <i class="fa s-icon-plus"></i>&nbsp;新規作成
          </a>
        </div>
      </div>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (!searching && filteredItems.length === 0) {
        <span>該当するデータはありません</span>
      }
      @if (filteredItems.length > 0) {
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        <table class="table table-bordered table-sm table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">状態</th>
              <th width="7%">ID</th>
              <th>作成者名</th>
              <th>件名</th>
              <th width="30%">本文</th>
              <th>更新日時</th>
              <th width="10%"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td class="text-center">
                  @if (item.status == 0) {
                    <button class="btn text-green p-0 bg-inherit active" type="button" title="有効" (click)="disable(item.id)">
                      <i class="fa fa-3x fa-toggle-on"></i>
                    </button>
                  }
                  @if (item.status == 1) {
                    <button class="btn text-secondary bg-inherit p-0 active" type="button" title="無効" (click)="enable(item.id)">
                      <i class="fa fa-3x fa-toggle-off"></i>
                    </button>
                  }
                </td>
                <td class="text-right">{{ item.id }}</td>
                <td>{{ item.user?.name }}</td>
                <td>{{ item.subject }}</td>
                <td class="td-scroll">
                  <div><span style="white-space: pre-line;">{{ item.message }}</span></div>
                </td>
                <td>{{ item.updatedAt | date:'yyyy/MM/dd HH:mm' }}</td>
                <td class="text-center">
                  <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                    [routerLink]="['/email/content', item.id, 'edit']" title="編集">
                    <i class="fa s-icon-edit fa-fw"></i>
                  </a>
                  @if (item.status === 1) {
                    <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button"
                      (click)="openDeleteModal(item)" title="削除">
                      <i class="fa s-icon-delete fa-fw"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
      }
    </div>
  </div>
</div>
@if (showDeleteModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title">メール文面の削除</h5>
          <button type="button" class="close" (click)="showDeleteModal = false">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">メール文面を削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="doDelete()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class EmailContentListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private emailContentService = inject(EmailContentService);
  private flash = inject(FlashService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  items: any[] = [];
  keyword = '';
  statusFilter: number | null = null;
  searching = true;
  statusOptions = [{ id: 0, name: '有効' }, { id: 1, name: '無効' }];
  readonly pageLimit = 100;
  pageIndex = 0;
  showDeleteModal = false;
  selectedItem: any = null;

  get filteredItems(): any[] {
    return this.items.filter(i => {
      if (this.statusFilter !== null && i.status !== this.statusFilter) return false;
      if (!matchesNestedKeyword(i, this.keyword)) return false;
      return true;
    });
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  private get filterStorageKey(): string {
    return `email-content.filters.${this.authState.currentUser?.id ?? 'current'}`;
  }

  filtersChanged(): void {
    this.pageIndex = 0;
    sessionStorage.setItem(this.filterStorageKey, JSON.stringify({
      keyword: this.keyword,
      status: this.statusFilter,
    }));
  }

  private restoreFilters(): void {
    try {
      const saved = JSON.parse(sessionStorage.getItem(this.filterStorageKey) ?? 'null');
      if (!saved || typeof saved !== 'object') return;
      this.keyword = typeof saved.keyword === 'string' ? saved.keyword : '';
      this.statusFilter = saved.status === 0 || saved.status === 1 ? saved.status : null;
    } catch {
      sessionStorage.removeItem(this.filterStorageKey);
    }
  }

  clearFilter(): void {
    this.pageIndex = 0;
    this.keyword = '';
    this.statusFilter = null;
    sessionStorage.removeItem(this.filterStorageKey);
  }

  openDeleteModal(item: any): void {
    this.selectedItem = item;
    this.showDeleteModal = true;
  }

  // 旧版 email-content.js:80-122: 戻り先頭要素0はdanger、それ以外success（5.5秒）、先頭へscroll後に再取得
  async enable(id: number): Promise<void> {
    if (this.userPermission > 10) return;
    const res: any = await this.emailContentService.updateStatus({ id, status: '0' });
    if (Array.isArray(res) && res[0] === 0) this.flash.create('danger', '選択したメール文面は有効にできません。', 5500);
    else this.flash.create('success', 'メール文面を有効にしました。', 5500);
    window.scrollTo(0, 0);
    await this.load();
  }

  async disable(id: number): Promise<void> {
    if (this.userPermission > 10) return;
    const res: any = await this.emailContentService.updateStatus({ id, status: 1 });
    if (Array.isArray(res) && res[0] === 0) this.flash.create('danger', '選択したメール文面は無効にできません。', 5500);
    else this.flash.create('success', 'メール文面を無効にしました。配信予約に設定しているものは有効です。', 5500);
    window.scrollTo(0, 0);
    await this.load();
  }

  async doDelete(): Promise<void> {
    this.showDeleteModal = false;
    if (this.userPermission > 10) return;
    const res: any = await this.emailContentService.updateStatus({ id: this.selectedItem.id, status: 2 });
    // 旧版 email-content.js:124-144: 予約利用中はdanger、それ以外success（5.5秒）、先頭へscroll後に再取得
    if (res?.isReservationExists) {
      this.flash.create('danger', '配信予約で使用中のメール文面は削除できません。', 5500);
    } else {
      this.flash.create('success', 'メール文面を削除しました。', 5500);
    }
    window.scrollTo(0, 0);
    await this.load();
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('文面作成', 'edit_note', true);
    this.restoreFilters();
    await this.load();
  }

  private async load(): Promise<void> {
    this.searching = true;
    try {
      this.items = await this.emailContentService.get() ?? [];
    } finally {
      this.searching = false;
    }
  }
}
